module["exports"] = ["Բն. ###", "Տուն ###"];